import PricingPage from "@/components/pricing/PricingPage"

type Props = {}

const index = (_props: Props) => {
  return <PricingPage />
}

export default index
